import { render, staticRenderFns } from "./AHAudioitemDetail.vue?vue&type=template&id=d8f0a72e&"
import script from "./AHAudioitemDetail.vue?vue&type=script&lang=ts&"
export * from "./AHAudioitemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports